module.exports = __webpack_public_path__ + "img/ic-note.fe1210f2.svg";